import { ReactNode } from 'react';
import P2GContentDropDown from '../P2GContentDropDown';
import { Draggable } from './Draggable';
import { P2GBox, P2GTooltip, P2GBadge, P2GText, P2GLinkGroup, P2GLink } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import CdnIconProxy from '~/apps/account-linking/components/CdnIconProxy';

interface props {
  id: string;
  detached: boolean;
  onPinned: () => void;
  onUnPinned: () => void;
  title?: string;
  iconSrc?: string;
  width?: string;
  icon?: ReactNode;
  classNames: string;
  palette?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  badgeContent?: number;
  onContentShow?: () => void;
  onContentHide?: () => void;
  additionalLinks?: ReactNode[];
  control?: ReactNode;
  children: ReactNode;
}

const DraggableMenu: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return props.detached ? (
    <>
      {props.control ? (
        <P2GBox onClick={props.onUnPinned}>{props.control}</P2GBox>
      ) : (
        <P2GTooltip title={props.title || ''}>
          <P2GBadge badgeContent={props.badgeContent || 0} colour="primary">
            <CdnIconProxy
              classNames={props.classNames}
              palette={props.palette}
              size="sm"
              src={props.iconSrc}
              onClick={props.onUnPinned}
            >
              {props.icon}
            </CdnIconProxy>
          </P2GBadge>
        </P2GTooltip>
      )}
      <Draggable
        id={props.id}
        onClose={props.onUnPinned}
        width={props.width || undefined}
        title={
          <P2GText variant="subtitle2" colour="primary">
            <strong>{props.title}</strong>
          </P2GText>
        }
        backgroundColour="white"
        p={1}
        additionalLinks={props.additionalLinks}
        bordered
      >
        <div style={{ width: '100%' }} onLoad={props.onContentShow}>
          {props.children}
        </div>
      </Draggable>
    </>
  ) : (
    <P2GContentDropDown
      onOpen={props.onContentShow}
      onClose={props.onContentHide}
      control={
        props.control || (
          <P2GBadge badgeContent={props.badgeContent || 0} colour="primary">
            <CdnIconProxy classNames={props.classNames} palette={props.palette} size="sm" src={props.iconSrc}>
              {props.icon}
            </CdnIconProxy>
          </P2GBadge>
        )
      }
    >
      <div style={{ width: props.width }}>{props.children}</div>
      <P2GBox textAlign="center" pt={1}>
        <P2GLinkGroup
          links={[
            <P2GLink onClick={props.onPinned}>{t('PIN_MENU_LINK', { defaultValue: 'Pin This Menu' })}</P2GLink>,
            ...((props.additionalLinks || []) as any)
          ]}
        />
      </P2GBox>
    </P2GContentDropDown>
  );
};
export default DraggableMenu;
